import {AppLayout} from "src/features/client";
import {Box, Button, Flex, Grid, Paper, TextInput} from "@mantine/core";
import {useEffect, useState} from "react";
import {Categories, CategoriesFilter, searchCategories} from "src/entities/categories";
import {CategoryItem} from "src/features/client/category/ui/category-item";
import {IconSearch} from "@tabler/icons-react";
import {useForm} from "@mantine/form";
import {useTranslation} from "react-i18next";
import { Helmet } from "react-helmet";
import {generateMetaData} from "src/shared/config/seo/meta-data";
import {useParams} from "react-router-dom";

export function CategoryChildrenClientPage() {
    const {t} = useTranslation();
    const [categories, setCategories] = useState<Categories[]>()
    const {parentId} = useParams()
    const form = useForm<CategoriesFilter>({
        initialValues: {
            title: "",
        }
    })

    const handleClickSearch = async (values?: CategoriesFilter) => {
        const res = await searchCategories({
            filter: {
                title: values?.title,
            },
            sorting: {sortBy: "ID", sortDirection: "DESC"},
            pageRequest: {limit: 100, page: 0}
        },false)
        setCategories(res?.content?.filter(el => (el.parentId?.id && el.parentId?.id) === parseInt(parentId || "")))
    }

    const metaData = generateMetaData(
        t("seo.title.categories"),
        t("seo.description.categories") + " " + categories?.reduce((acc, el) => acc += `${el.titleRu} |`, ""),
        "/categories-list");


    useEffect(() => {
        handleClickSearch()
    }, []);
    return (
        <AppLayout>
            <Helmet>
                <title>{metaData.title}</title>
                {metaData.description && <meta name="description" content={metaData.description}/>}
                {metaData.openGraph && (
                    <meta property="og:title" content={metaData.openGraph.title}/>
                )}
                {metaData.openGraph && (
                    <meta property="og:description" content={metaData.openGraph.description}/>
                )}
                {metaData.openGraph && (
                    <meta property="og:image" content={metaData.openGraph.images}/>
                )}
                {metaData.openGraph && (
                    <meta property="og:url" content={metaData.openGraph.url}/>
                )}
                {metaData.twitter && (
                    <meta name="twitter:card" content={metaData.twitter.card}/>
                )}
                {metaData.twitter && (
                    <meta name="twitter:title" content={metaData.twitter.title}/>
                )}
                {metaData.twitter && (
                    <meta name="twitter:description" content={metaData.twitter.description}/>
                )}
                {metaData.twitter && (
                    <meta name="twitter:image" content={metaData.twitter.images}/>
                )}
            </Helmet>
            <Paper mt={20} className="container" shadow="lg" style={{borderRadius: "16px"}} mb={16} p="12px 16px">
                <form onSubmit={form.onSubmit(handleClickSearch)}>
                    <Flex align="center" gap={10}>
                        <TextInput
                            {...form.getInputProps("title")}
                            styles={{
                                input: {
                                    border: "none"
                                }
                            }}
                            fz={16} fw={500}
                            c="#6B7583"
                            placeholder={t("form.label.searchText")}
                            w="100%"/>
                        <Button type="submit" bg="#1A2085" style={{borderRadius: "8px", height: "fit-content"}} p={12}>
                            <IconSearch/>
                        </Button>
                    </Flex>
                </form>
            </Paper>
            <Box bg="#FAFAFA" py={{base: 40, sm: 80}}>
                <Grid className="container" gutter={{base: 24, sm: 40}}>
                    {categories?.map((category) => (
                        <Grid.Col key={category.id} span={{base: 12, sm: 6,md: 4, xl: 3}}>
                            <CategoryItem  data={category}/>
                        </Grid.Col>
                    ))}
                </Grid>
            </Box>
        </AppLayout >
    );
}
